import * as React from "react";
import { useParams } from "react-router-dom";
import { PageUrl } from "src/routes/PageUrl";

import { RecordCardCommonBox } from "../RecordCardCommonBox";

export const RecordHistoryPage: React.FC = () => {
  const { id = "" } = useParams();
  return (
    <RecordCardCommonBox
      mode="history"
      recordId={id}
      title={[{ title: "Каталоги", page: PageUrl.catalogs }]}
    >
      Пока не брали в работу
    </RecordCardCommonBox>
  );
};
